// src/components/experts/ExpertDetails.jsx
import React from 'react';
import ExpertCard from './ExpertCard';
import { motion } from 'framer-motion';
import expertsData from '../../data/db.json'; // Import the JSON data

const ExpertDetails = () => {
  const experts = expertsData.experts; // Access the 'experts' array from the imported data

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.section
      className="py-16 mb-8"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.h2
        className="text-3xl font-bold text-gray-800 mb-8 text-center"
        variants={itemVariants}
      >
        Our Esteemed Experts
      </motion.h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {experts.map((expert, index) => (
          <motion.div key={index} variants={itemVariants}>
            <ExpertCard expert={{
              name: expert.name,
              title: expert.designation,
              image: expert.imagePath,
              specialization: expert.specialization, // Assuming this exists
              year: expert.year,                 // Assuming this exists
              bio: expert.bio,                   // Assuming this exists
            }} />
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};

export default ExpertDetails;